import { Download } from "lucide-react";
import { useLang } from "../i18n";
import { Reveal, Eyebrow, SectionShell } from "./Reveal";

export const DRIVE_BOZZA_URL =
  "https://drive.google.com/file/d/1_raCAa_TznAnfkiubAFOEH-cjQRo28Hw/view?usp=sharing";

export default function AudioBozza() {
  const { t } = useLang();

  return (
    <SectionShell id="musica" testid="audio-player-section" className="bg-white border-y border-slate-100">
      <div className="max-w-3xl mx-auto text-center">
        <Reveal>
          <Eyebrow>{t.audio.eyebrow}</Eyebrow>
          <h2 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">
            {t.audio.title}
          </h2>
          <p className="mt-4 text-slate-600 text-base sm:text-lg leading-relaxed">{t.audio.sub}</p>
          <a
            href={DRIVE_BOZZA_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="audio-download-btn"
            className="group mt-7 inline-flex items-center gap-2 rounded-2xl bg-sky-600 px-6 py-3.5 font-semibold text-white shadow-lg shadow-sky-600/25 hover:bg-sky-700 transition-all"
          >
            <Download size={18} className="transition-transform group-hover:translate-y-0.5" />
            {t.audio.downloadLink}
          </a>
          <p
            className="mt-6 inline-flex rounded-full border border-amber-200 bg-amber-50 px-4 py-1.5 font-mono text-xs sm:text-sm font-semibold text-amber-700"
            data-testid="audio-theme-marker"
          >
            -Il tema musicale entra ad 1'21"-
          </p>
          <p className="mt-7 text-sm text-slate-500 leading-relaxed">{t.audio.note}</p>
        </Reveal>
      </div>
    </SectionShell>
  );
}
